/** @jsx h */
import { labels } from '../../config';

const TeaserGlobal = ({ result }) => {
  return (
    <article className="teaser-search ">
      <div className="teaser-search__teaser">
        <header className="teaser-search__header">
          {result.mark && (
            <div className="teaser-search__category">
              <div className="meta-category meta-category--teaser-search">
                <span className="meta-category__icon" />
                <span className="sr-only">{labels.document.category}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: Array.isArray(result.mark)
                      ? result.mark.join(
                          '<span class="meta-category__separator" aria-hidden="true">|</span>'
                        ) +
                        (result?.markAdditional
                          ? `<span class="meta-category__separator" aria-hidden="true">|</span>${result.markAdditional}`
                          : '')
                      : result.mark +
                        (result?.markAdditional
                          ? `<span class="meta-category__separator" aria-hidden="true">|</span>${result.markAdditional}`
                          : ''),
                  }}
                />
              </div>
            </div>
          )}
          {result.publishingDate && (
            <time className="teaser-search__date">{result.publishingDate}</time>
          )}

          {result.event && (
            <div className="teaser-search__event">
              <div className="meta-event ">
                {result.event.date && (
                  <div className="meta-event__day">
                    <span className="meta-event__icon meta-event__icon--day icon icon--calendar">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-calendar" />
                      </svg>

                      <span className="sr-only">{labels.document.date}</span>
                    </span>
                    <time className="meta-event__day-start">
                      {result.event.date}
                    </time>
                  </div>
                )}
                {result.event.time && (
                  <div className="meta-event__time">
                    <span className="meta-event__icon meta-event__icon--time icon icon--clock">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-clock" />
                      </svg>

                      <span className="sr-only">{labels.document.time}</span>
                    </span>
                    <time>
                      {result.event.time} {labels.document.clock}
                    </time>
                  </div>
                )}
                {result.event.location && (
                  <div className="meta-event__location">
                    <span className="meta-event__icon meta-event__icon--location icon icon--map-pin-small">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-map-pin-small" />
                      </svg>
                      <span className="sr-only">
                        {labels.document.location}
                      </span>
                    </span>
                    <div class="meta-event__text">{result.event.location}</div>
                  </div>
                )}{' '}
              </div>
            </div>
          )}
          <h3 className="teaser-search__heading">
            {result.url ? (
              <a
                className="teaser-search__link"
                href={result.url}
                {...(result.isExternal
                  ? { target: '_blank', rel: 'noopener' }
                  : '')}
              >
                {result.isExternal && (
                  <span class="teaser-search__link-icon icon icon--arrow-external">
                    <svg class="icon__svg" role="img" aria-hidden="true">
                      <use href="#icon-arrow-external" />
                    </svg>
                    <span class="sr-only">{labels.document.externalLink}:</span>
                  </span>
                )}
                {result.title}
              </a>
            ) : (
              result.title
            )}
          </h3>
        </header>
        {result.teaser && (
          <div className="teaser-search__content">
            <p
              dangerouslySetInnerHTML={{
                __html: result.teaser,
              }}
            />
          </div>
        )}
      </div>
    </article>
  );
};

export default TeaserGlobal;
